{
  "cycle.entite.referentiel_revision_contributeurs": "Contributors to reference revisions",
  "cycle.entite.referentiel_revisions": "Organisation reference revisions",
  "journalAudit.action.import.referential_applied": "Axis import applied: draft axes submitted for validation",
  "journalAudit.action.org_requirement.revision_saved": "Organisation requirement: revision saved",
  "journalAudit.action.org_requirement.withdrawn": "Organisation requirement withdrawn (reason)",
  "journalAudit.action.referentiel.refused": "Reference revision refused",
  "journalAudit.action.referentiel.submitted": "Reference revision submitted for validation",
  "journalAudit.action.referentiel.validated": "Reference revision validated",
  "journalAudit.action.referentiel.withdrawn_from_validation": "Reference revision withdrawn from validation",
  "journalAudit.action.taxonomy.axis_declared": "Axis declared as draft"
}
